const t = {
  menuitem: { selectionAttribute: "none" },
  menuitemcheckbox: { selectionAttribute: "checked", supportsMultiSelection: !0 },
  menuitemradio: { selectionAttribute: "checked" },
  option: { selectionAttribute: "selected", supportsMultiSelection: !0 },
  tab: { selectionAttribute: "selected" },
  gridcell: { selectionAttribute: "selected", supportsMultiSelection: !0 },
  row: { selectionAttribute: "selected", supportsMultiSelection: !0 },
  treeitem: { selectionAttribute: "selected", supportsMultiSelection: !0 },
  rowheader: { selectionAttribute: "selected" },
  columnheader: { selectionAttribute: "selected" }
}, r = (i, e) => {
  switch ((t[i] || t.menuitem).selectionAttribute) {
    case "selected":
      return { "aria-selected": e };
    case "checked":
      return { "aria-checked": e };
    case "none":
    default:
      return {};
  }
};
export {
  r as getAriaAttributes
};
//# sourceMappingURL=index.es531.js.map
